import React, {ReactNode} from "react"
import Header from "../boxes/Header"
import {t} from "../../i18n"
import {Form, FormRenderProps} from "react-final-form";
import userApi, {UserEmail} from "../../api/user";
import Box from "../boxes/Box";
import TextField from "../form-fields/TextField";
import SubmitError from "../form-fields/SubmitError";
import {localizedLoadPage} from "../../utils/navigation";
import Button from "../controls/Button";

const ResetPasswordForm: React.FC = () => {

  const submitForm = async (values: UserEmail): Promise<FormErrors | void> => {
    return userApi.newPassword(values)
      .then(() => localizedLoadPage("/session/new"))
      .catch((errors: FormErrors) => errors)
  }

  return (
    <div>
      <Header i18nKey="landing.forgot.title"/>
      <p className="u-mt-40 u-max-w-580">
        {t("landing.forgot.text1")} {t("landing.forgot.text2")}
      </p>
      <Form
        onSubmit={submitForm}
        render={(renderProps: FormRenderProps<UserEmail>): ReactNode => {
          const {handleSubmit, submitError, submitting} = renderProps
          return (
            <Box className="mz-new-user-fields" maxWidth="380px">
              <form id="form_reset_password" onSubmit={handleSubmit}>
                <TextField
                  autoFocus
                  className="u-mt-r2"
                  i18key="attributes.email"
                  id="field_email"
                  name="email"
                  type="email"
                />
                <SubmitError className="u-mt-40" errors={submitError}/>
                <Button
                  className="u-mt-40 u-min-w-140"
                  disabled={submitting}
                  i18key={"landing.forgot.title"}
                  id="btn_submit"
                  large
                  submit
                  primary={true}
                />
              </form>
            </Box>
          )
        }}
      />
    </div>
  )
}

export default ResetPasswordForm
